import { useAppDispatch } from "@/store";
import endpoints from "@/api/endpoints";
import httpClient from "@/api/http-client";
import { authActions } from "@/store/slices/auth";
import { useFormik } from "formik";
import Image from "next/image";
import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import styles from "@/styles/forgotpassword.module.scss";
import { toast } from "react-toastify";
import * as Yup from "yup";

const ForgotPasswordForm = () => {
  const dispatch = useAppDispatch();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const otpFormik = useFormik({
    initialValues: {
      mobile: "",
    },
    validationSchema: Yup.object({
      mobile: Yup.string().required("Mobile is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        // const { data } = await httpClient.post(
        //   endpoints.auth.forgotPassword(),
        //   {
        //     mobile: values.mobile,
        //   }
        // );
        // toast(data.message, {
        //   type: "success",
        //   toastId: "auth-otp-success",
        // });
        // setStep(2);
      } catch (error: any) {
        if (error.response.data?.errors) {
          toast(
            (Object.values(error.response.data.errors) as any)[0][0] as string,
            {
              type: "error",
              toastId: "auth-otp-error",
            }
          );
        } else {
          toast("Something went wrong! Try again!", {
            type: "error",
            toastId: "auth-otp-error",
          });
        }
      }
      setLoading(false);
    },
  });

  const changePasswordFormik = useFormik({
    initialValues: {
      otp: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string().required("OTP is required"),
      newPassword: Yup.string().required("Password is required"),
      confirmPassword: Yup.string()
        .required("Confirm password is required")
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        // const { data } = await httpClient.post(
        //   endpoints.auth.changePassword(),
        //   {
        //     mobile: otpFormik.values.mobile,
        //     otp: values.otp,
        //     new_password: values.newPassword,
        //     confirm_password: values.confirmPassword,
        //   }
        // );
        // toast(data.message, {
        //   type: "success",
        //   toastId: "auth-otp-success",
        // });
        // dispatch(authActions.setActiveTab("login"));
      } catch (error: any) {
        if (error.response.data?.errors) {
          toast(
            (Object.values(error.response.data.errors) as any)[0][0] as string,
            {
              type: "error",
              toastId: "auth-otp-error",
            }
          );
        } else {
          toast("Something went wrong! Try again!", {
            type: "error",
            toastId: "auth-otp-error",
          });
        }
      }
      setLoading(false);
    },
  });

  return (
    <div className={styles.login_container}>
      <div className={styles.login_image}>
        <Image
          src="https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/EXfVWvIz5SFqWvT8MjQ2kNZT0z7fLpusbEtpVMCo.jpeg"
          alt="Login image"
          width={399}
          height={532}
        />
      </div>
      {step == 1 && (
        <div className={styles.contact_form_wrapper}>
          <form onSubmit={otpFormik.handleSubmit}>
            <h1>Forgot Password</h1>
            <div className="form-item">
              <input
                type="text"
                placeholder="Mobile No."
                {...otpFormik.getFieldProps("mobile")}
              />
              {otpFormik.touched.mobile && otpFormik.errors.mobile ? (
                <small className="text-danger">{otpFormik.errors.mobile}</small>
              ) : null}
            </div>
            <button
              role="button"
              aria-label="Send OTP"
              className={styles.submit_btn}
              type="submit"
              disabled={loading}
            >
              Send OTP {loading && <Spinner animation="border" size="sm" />}
            </button>
            <div className="row">
              <div className="col-md-7">
                <p>
                  New here?
                  <span
                    onClick={() =>
                      dispatch(authActions.setActiveTab("register"))
                    }
                    className={`${styles.new_here} ${"ms-1 pointer"}`}
                  >
                    Click to register
                  </span>
                </p>
              </div>
            </div>
          </form>
        </div>
      )}
      {step == 2 && (
        <div className={styles.contact_form_wrapper}>
          <form onSubmit={changePasswordFormik.handleSubmit}>
            <h1>Forgot Password</h1>
            <div className="form-item">
              <input
                type="text"
                placeholder="OTP"
                autoComplete="one-time-code"
                {...changePasswordFormik.getFieldProps("otp")}
              />
              {changePasswordFormik.touched.otp &&
              changePasswordFormik.errors.otp ? (
                <small className="text-danger">
                  {changePasswordFormik.errors.otp}
                </small>
              ) : null}
            </div>
            <div className="form-item">
              <input
                type="password"
                placeholder="New Password"
                autoComplete="new-password"
                {...changePasswordFormik.getFieldProps("newPassword")}
              />
              {changePasswordFormik.touched.newPassword &&
              changePasswordFormik.errors.newPassword ? (
                <small className="text-danger">
                  {changePasswordFormik.errors.newPassword}
                </small>
              ) : null}
            </div>
            <div className="form-item">
              <input
                type="password"
                placeholder="Confirm Password"
                autoComplete="new-password"
                {...changePasswordFormik.getFieldProps("confirmPassword")}
              />
              {changePasswordFormik.touched.confirmPassword &&
              changePasswordFormik.errors.confirmPassword ? (
                <small className="text-danger">
                  {changePasswordFormik.errors.confirmPassword}
                </small>
              ) : null}
            </div>
            <button
              role="button"
              aria-label="Change Password"
              className={styles.submit_btn}
              type="submit"
              disabled={loading}
            >
              Change Password{" "}
              {loading && <Spinner animation="border" size="sm" />}
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default ForgotPasswordForm;
